<template>
	<v-dialog persistent width="340" :value="isPopup">
		<div class="deletePaymentWrapper">
			<div class="popupHead">Delete payment
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="paymentGroup">
				<v-radio-group v-model="payment_type">
					<v-radio
							v-for="item in paymentGroupList"
							:key="item.id"
							:label="item.name"
							:value="item.id"
					></v-radio>
				</v-radio-group>
			</div>
			<button-groups
					padding="0 0 20px"
					@updateBtnClose="onClose"
					@updateSave="onSave"
					apply-text="ok"
					center
			></button-groups>
		</div>
	</v-dialog>
</template>

<script>
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";

export default {
	name: "DeletePayment",
	components: {
		ButtonGroups
	},
	data: () => ({
		isPopup: true,
		payment_type: 1,
		paymentGroupList: [
			{ id: 1, name: 'This payment' },
			{ id: 2, name: 'This and following payments' },
			{ id: 3, name: 'All payments' }
		]
	}),
	methods: {
		onClose() {
			this.$emit('updateClose');
		},
		onSave() {
			this.$emit('updateDeleteItem', this.payment_type);
		}
	}
};
</script>

<style scoped lang="scss">

.deletePaymentWrapper {
	background: #1C1C28;

	.popupHead {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 500;
		font-size: 20px;
		line-height: 24px;
		letter-spacing: 0.25px;
		color: #FFFFFF;
		padding: 20px 20px 0;
	}
}
</style>
<style lang="scss">
.paymentGroup .v-label {
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #FFFFFF;
}
</style>
